module.exports = __webpack_public_path__ + "img/selectCompany.b3e5e26b.png";